import { SurfaceTaxonomy } from '@app/category-taxonomy/models/types/surface-taxonomy.type';
import { ChannelClient } from '@app/core/models/enums/channel-client.enum';

export const CATEGORY_GROUP_NONE: string = 'none';

// Legacy Taxonomy IDs
export const FACEBOOK_TAXONOMY_ID: string = '41';
export const GOOGLE_TAXONOMY_ID: string = '116';
export const GOOGLE_UCP_TAXONOMY_ID: string = '118';
export const MICROSOFT_TAXONOMY_ID: string = '104';
export const PINTEREST_TAXONOMY_ID: string = '108';
export const TIKTOK_ADS_TAXONOMY_ID: string = '107';

// New Taxonomies as a Service Slugs
export const FACEBOOK_TAXONOMY_SLUG: string = 'taxonomy_service:meta_ads_and_shops_local:latest';
export const GOOGLE_TAXONOMY_SLUG: string = 'taxonomy_service:google_merchant_api:latest';
/** Google's taxonomy for SFTP feeds. The destination registry also gives it to Meta Ads. */
export const GOOGLE_SHOPPING_SFTP_TAXONOMY_SLUG: string = 'taxonomy_service:google_shopping_sftp:latest';
export const GOOGLE_UCP_TAXONOMY_SLUG: string = 'taxonomy_service:google_ucp:latest';
export const MICROSOFT_TAXONOMY_SLUG: string = 'taxonomy_service:microsoft_ads:latest';
export const PINTEREST_TAXONOMY_SLUG: string = 'taxonomy_service:pinterest:latest';
export const TIKTOK_ADS_TAXONOMY_SLUG: string = 'taxonomy_service:tiktok_ads:latest';
export const AMAZON_PI_TAXONOMY_SLUG: string = 'taxonomy_service:amazon_price_and_inventory:latest';
export const EBAY_PI_TAXONOMY_SLUG: string = 'taxonomy_service:ebay_inventory_and_price:latest';
export const TIKTOK_SHOP_PI_V2_TAXONOMY_SLUG: string = 'taxonomy_service:tiktok_shop_price_and_inventory_v2:latest';

/**
 * Taxonomies Surface offers. The Taxonomy page lists all of them, and the Categorization drawer offers
 * those with categories.
 */
export const SURFACE_TAXONOMIES: Map<string, SurfaceTaxonomy> = new Map<string, SurfaceTaxonomy>([
    // Legacy Taxonomies
    [FACEBOOK_TAXONOMY_ID, {
        name: 'Meta Ads & Shops (Facebook/Instagram)',
        icon: '/dist/app/assets/brands/icons/meta.svg',
        legacyClient: ChannelClient.Facebook
    }],
    [GOOGLE_TAXONOMY_ID, {
        icon: '/dist/app/assets/brands/icons/google.svg',
        legacyClient: ChannelClient.Google
    }],
    [GOOGLE_UCP_TAXONOMY_ID, {
        icon: '/dist/app/assets/brands/icons/gemini.svg',
        legacyClient: ChannelClient.GoogleUCP
    }],
    [MICROSOFT_TAXONOMY_ID, {
        name: 'Microsoft Ads',
        icon: '/dist/app/assets/brands/icons/microsoft.svg',
        legacyClient: ChannelClient.MicrosoftAds
    }],
    [PINTEREST_TAXONOMY_ID, {
        icon: '/dist/app/assets/brands/icons/pinterest.svg',
        legacyClient: ChannelClient.Pinterest
    }],
    [TIKTOK_ADS_TAXONOMY_ID, {
        icon: '/dist/app/assets/brands/icons/tiktok.svg',
        legacyClient: ChannelClient.TikTokAds
    }],
    // New Taxonomies as a Service options. The price and inventory taxonomies have no categories.
    [FACEBOOK_TAXONOMY_SLUG, {
        name: 'Meta Ads & Shops (Facebook/Instagram)',
        icon: '/dist/app/assets/brands/icons/meta.svg'
    }],
    [GOOGLE_TAXONOMY_SLUG, {
        name: 'Google Shopping (Merchant API)',
        icon: '/dist/app/assets/brands/icons/google.svg'
    }],
    [GOOGLE_SHOPPING_SFTP_TAXONOMY_SLUG, {
        name: 'Google Shopping (SFTP)',
        icon: '/dist/app/assets/brands/icons/google.svg'
    }],
    [GOOGLE_UCP_TAXONOMY_SLUG, {
        name: 'Google UCP',
        icon: '/dist/app/assets/brands/icons/gemini.svg'
    }],
    [MICROSOFT_TAXONOMY_SLUG, {
        name: 'Microsoft Ads',
        icon: '/dist/app/assets/brands/icons/microsoft.svg'
    }],
    [PINTEREST_TAXONOMY_SLUG, {
        name: 'Pinterest',
        icon: '/dist/app/assets/brands/icons/pinterest.svg'
    }],
    [TIKTOK_ADS_TAXONOMY_SLUG, {
        name: 'TikTok Ads',
        icon: '/dist/app/assets/brands/icons/tiktok.svg'
    }],
    [AMAZON_PI_TAXONOMY_SLUG, {
        name: 'Amazon Price and Inventory',
        icon: '/dist/app/assets/brands/icons/amazon.svg',
        hasCategories: false
    }],
    [EBAY_PI_TAXONOMY_SLUG, {
        name: 'eBay Inventory and Price',
        icon: '/dist/app/assets/brands/icons/ebay.svg',
        hasCategories: false
    }],
    [TIKTOK_SHOP_PI_V2_TAXONOMY_SLUG, {
        name: 'Tiktok Shop Price and Inventory V2',
        icon: '/dist/app/assets/brands/icons/tiktok.svg',
        hasCategories: false
    }]
]);
